export const updateProfileImage = (imageUrl) => ({
  type: 'UPDATE_PROFILE_IMAGE',
  payload: imageUrl,
});

export const notificationCount = (count) => ({
  type: 'NOTIFICATION_COUNT',
  payload: count,
});

export const notificationList = (list) => ({
  type: 'NOTIFICATION_LIST',
  payload: list,
});


